/* eslint-disable */
import { THEME_BREAKPOINT_MAX } from '../../../Constants/Theme/Theme.constants';
import throwParameterRequiredError from '../../../Errors/General/ParameterRequired.error';

/**
 * Get the width `step`
 * @export
 * @param {EntryBreakpoints} breakpoints The breakpoints name for the `entry`
 * @returns {WidthStep} The `step`
 */
const themeStepGet = (breakpoints = throwParameterRequiredError(`entry`)) => {
  const currentWidth = typeof window === `object` ? window.innerWidth : 0;
  /** @type {WidthStep | null} */
  let width = null;
  let index = 1;
  while (width === null && index < breakpoints.length) {
    const currentBreakpoint = breakpoints[index];
    if (currentWidth < currentBreakpoint.unit) {
      width = breakpoints[index - 1].step;
      break;
    }
    index += 1;
  }
  if (width === null) {
    return THEME_BREAKPOINT_MAX;
  }
  return width;
};

export default themeStepGet;
